import script from "./ReportSummaryRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportSummaryRenderer.vue?vue&type=script&setup=true&lang=js"

import "./ReportSummaryRenderer.vue?vue&type=style&index=0&id=888b7674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888b7674"]])

export default __exports__